import { DomainInfo } from '../services/white-label/domain-info';

export const DEFAULT_DOMAINS = ['localhost', 'internaldev', 'dev', 'beta', 'qa', 'www', 'sigsense'];
export const DEFAULT_PRODUCTION_DOMAIN = 'sigsense';

export const DEFAULT_BRANDING_DATA: DomainInfo = {
    provider: 'Sigsense',
    prefix: 'sigsense',
    name: '',
    links: {
        self: '',
    },
    assets: {
        favicon: '/favicon.ico',
        darkLogo: '/assets/img/product_logo_medium_dark_bg.png',
        lightLogo: '/assets/img/product_logo_medium_light_bg.png',
        loginProductLogo: '/assets/img/product_logo_login.png',
        providerLogo: '/assets/img/sigsense_provider_logo.png',
    },
    description: `Sigsense is a predictive asset management platform that enables deep,
                flexible insight into the equipment you care about.
                Our AI analytics allow you to be the first to know about critical service
                and maintenance issues and help drive real improvements in utilization and process bottlenecks,
                and operational and service efficiency.<br/><br/>Enter the information below to begin using Sigsense to monitor,
                diagnose, and manage your equipment with predictive AI analytics.`,
};

export enum DOMAIN_ASSETS {
    favicon = 'favicon',
    darkLogo = 'solution_logo_dark',
    lightLogo = 'solution_logo_light',
    providerLogo = 'provider_logo_light',
}
